import React, { useEffect, useMemo, useState } from 'react';
import { ButtonText, ButtonWrapper, FilledButton, HollowButton } from './styles';
import useLocalization from '../../../../hooks/useLocalization';
import { Lang } from '@brg/api';
import { useBreakpoint } from '@brg/ui';
import { LayoutConst } from '../../../../constants/media';
export function CourseCustomButton(_a) {
    var href = _a.href, text = _a.text, textMobile = _a.textMobile, type = _a.type;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var isMobile = useBreakpoint(743);
    var button = useMemo(function () {
        var normalizedHref = href &&
            !href.startsWith('http') &&
            !href.startsWith('/') &&
            !href.startsWith('#') &&
            !href.startsWith('mailto:') &&
            !href.startsWith('tel:')
            ? "https://".concat(href)
            : href;
        if (type === 'hollow') {
            return (React.createElement(HollowButton, { onClick: function () { return window.open(normalizedHref, '_blank'); } },
                React.createElement(ButtonText, { style: { textAlign: 'center' } }, Lang(isMobile ? textMobile : text, language))));
        }
        return (React.createElement(FilledButton, { onClick: function () { return window.open(normalizedHref, '_blank'); } },
            React.createElement(ButtonText, { style: { textAlign: 'center' } }, Lang(isMobile ? textMobile : text, language))));
    }, [type, text, textMobile, href, language]);
    return button;
}
//# sourceMappingURL=courseCustomButton.js.mapimport React, { useEffect, useMemo, useState } from 'react';
import { ButtonText, ButtonWrapper, FilledButton, HollowButton } from './styles';
import useLocalization from '../../../../hooks/useLocalization';
import { Lang } from '@brg/api';
import { useBreakpoint } from '@brg/ui';
import { LayoutConst } from '../../../../constants/media';
export function CourseCustomButton(_a) {
    var href = _a.href, text = _a.text, textMobile = _a.textMobile, type = _a.type;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var isMobile = useBreakpoint(743);
    var button = useMemo(function () {
        var normalizedHref = href &&
            !href.startsWith('http') &&
            !href.startsWith('/') &&
            !href.startsWith('#') &&
            !href.startsWith('mailto:') &&
            !href.startsWith('tel:')
            ? "https://".concat(href)
            : href;
        if (type === 'hollow') {
            return (React.createElement(HollowButton, { onClick: function () { return window.open(normalizedHref, '_blank'); } },
                React.createElement(ButtonText, { style: { textAlign: 'center' } }, Lang(isMobile ? textMobile : text, language))));
        }
        return (React.createElement(FilledButton, { onClick: function () { return window.open(normalizedHref, '_blank'); } },
            React.createElement(ButtonText, { style: { textAlign: 'center' } }, Lang(isMobile ? textMobile : text, language))));
    }, [type, text, textMobile, href, language]);
    return button;
}
//# sourceMappingURL=courseCustomButton.js.map